import { useTranslation } from "react-i18next"
import { useMemo } from "react"
import moment from "moment"
import { getMomentLocale } from "../i18n"

export const useLocaleData = () => {
  const { i18n } = useTranslation()
  return useMemo(() => {
    moment.locale(getMomentLocale(i18n.language))
    return moment.localeData()
  }, [i18n.language])
}